module.exports = __webpack_public_path__ + "static/media/finished_course.79556576.png";